export function DemoProjects() {
  const projects = [
    {
      title: 'Fendirest Center for Environmental Studies',
      description: 'Education and Research Center',
      image: '/images/demo1.jpg'
    },
    {
      title: 'Regional Science Consortium',
      description: 'Water Intelligence at Presqu\'ile',
      image: '/images/demo2.jpg'
    }
  ]

  return (
    <section id="projects" className="py-24 bg-white">
      <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[140px]">
        <h2 className="text-3xl font-bold text-[#4D4D4D] mb-10">Demo Projects</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {projects.map((project, idx) => (
            <div key={idx} className="group rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition duration-300">
              {/* Project Image */}
              <div className="relative overflow-hidden text-[#4D4D4D] h-72">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                />
              </div>

              {/* Project Info */}
              <div className="bg-white p-8">
                <h3 className="text-xl font-bold text-[#4D4D4D] mb-3">
                  {project.title}
                </h3>
                <p className="text-base text-gray-600">
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
